import frame from '@/frame/frame'

import login from './student/login.js'
import course from './student/course.js'
import courseware from './student/courseware.js'
import msg from './student/msg.js'
import user from './student/user.js'
import quiz from './student/quiz.js'
import discuss from './student/discuss.js'
import group from './student/group.js'
import groupCurrent from './student/group-current.js'
import homework from './student/homework.js'
import test from './student/test.js'

export default [
    {path:'login', component:frame, children: login },
    {path:'course', component:frame, children: course },
    {path:'courseware', component:frame, children: courseware },
    {path:'msg', component:frame, children: msg },
    {path:'user', component:frame, children: user },
    {path:'group', component:frame, children: group },
    {path:'group/current', component:frame, children: groupCurrent },
    {path:'class-quiz', component:frame, children: quiz },
    {path:'discuss', component:frame, children: discuss },
    {path:'homework', component:frame, children: homework },
    {path:'test', component:frame, children: test }
]



// WEBPACK FOOTER //
// ./src/router/student.js